export const ANALYTICS_TARGET = "category";
export const ANALYTICS_TARGET_CATEGORY_CAROUSEL = "category_carousel";
